export default __webpack_public_path__ + "static/sc-local2-9b84bfa557170b63cb0d3c52267d9813.webp";